// removed by extract-text-webpack-plugin
module.exports = {"group":"group__1qkdJ","label":"label__F1-3e","input-label":"input-label__1x70F","input":"input__20HF0","file-input":"file-input__Slm7W","placeholder":"placeholder__2VHQb","info":"info__2RNgD","option-group":"option-group__2aGoN","submit":"submit__2-1_t","submit-button":"submit-button__1fhnm","input-error":"input-error__11Pv3","edit":"edit__2c8fl","error-message":"error-message__1zIjW","success-message":"success-message__2qbhE"};


//////////////////
// WEBPACK FOOTER
// ./styles/docs.scss
// module id = 1201
// module chunks = 68